var idmDragWorkspaceInfo = {};
var cacheData = {};
/**
 * 对外开放的组件属性修改改变处理函数
 * attrData:{attrKey1,attrKey2}  要变更的属性对象
 * modulePackageid:对应的组件包ID
 * attrDataInnerIndex:属性对应的类型，默认为-1是组件属性，如果为组件内部的容器属性，则需要传指定容器的idm-container-index
 * responseProps:是否响应props属性，默认为false，如果为true，将会调用idmProps方法把最新的熟悉传递给组件进行响应
 */
function externalMixAttributeChangeHandle(attrData,modulePackageid,attrDataInnerIndex,responseProps){
    if(window.IdmBuiltin_externalMixAttributeChangeHandle){
        return window.IdmBuiltin_externalMixAttributeChangeHandle(attrData,modulePackageid,attrDataInnerIndex,responseProps)
    }
}
/**
 * 获取拖拽工作区的信息
 * @returns 
 * {
    key: "dragworkspace",
    width: 400,
    height: 300,
    leftAreaOpened: true,
    rightAreaOpened: true,
    topAreaOpened: true,
    bottomAreaOpened: true,
    //全屏状态下的临时打开窗口
    leftAreaLsOpened: false,
    rightAreaLsOpened: false,
    topAreaLsOpened: false,
    bottomAreaLsOpened: false,
    }
 */
function getDragWorkspaceInfo(){
    return idmDragWorkspaceInfo;
}
/**
 * 设置拖拽区的信息
 * @param {
        key: "dragworkspace",
        width: 400,
        height: 300,
        leftAreaOpened: true,
        rightAreaOpened: true,
        topAreaOpened: true,
        bottomAreaOpened: true,
        //全屏状态下的临时打开窗口
        leftAreaLsOpened: false,
        rightAreaLsOpened: false,
        topAreaLsOpened: false,
        bottomAreaLsOpened: false,
      } object 
 */
function setDragWorkspaceInfo(object){
    idmDragWorkspaceInfo = object;
}
export default {
    cacheData,
    externalMixAttributeChangeHandle,
    getDragWorkspaceInfo,
    setDragWorkspaceInfo
}